import { ActionTree } from 'vuex'
import NotificationsHelper from '@/helpers/notifications/notifications.js'
import { Notification } from '@/store/notifications/types'
import store from '@/store'
import { RootState } from '@/store/types'
import { TagsHelpers } from '@/helpers/mainExports'

export const actions: ActionTree<Notification, RootState> = {
  async fillNotification({ commit }, { agentId }) {
    const { persons } = store.state.persons as any
    const storedTags = await TagsHelpers.getTagsFromStorage()
    NotificationsHelper.getNotification(agentId)
      .then(notification => {
        notification.to.map(recipient => {
          const personsNotifications = persons.filter(
            person => recipient.user_id == person.uriId
          )

          personsNotifications.map(person => {
            commit('setEmailsNotification', {
              agentId: agentId,
              fullName: `${person.first_name} ${person.last_name}`
            })
          })
        })

        notification.to.map(recipient => {
          const personGroupNotifications = storedTags.filter(
            personGroupNotification =>
              recipient.user_id == personGroupNotification.id
          )

          personGroupNotifications.map(group => {
            commit('setGroupEmailsNotification', {
              agentId: agentId,
              groupName: group.label,
              color: group.color
            })
          })
        })
      })
      .catch(err => {
        if (err.error != 'com.magenta.error.not_found') console.error(err)
      })
  },
  resetNotificationState({ commit }) {
    commit('resetState')
  }
}
